export const ADMIN_PLATFORMS = ["ios", "android", "web", "api", "unknown"] as const;
export const ADMIN_PROJECTION_FRESHNESS_VALUES = ["fresh", "stale", "partial", "unavailable"] as const;
export const ADMIN_APP_SIGNAL_KEYS = [
  "auth_session",
  "user_profile",
  "pet_profile",
  "social_profile",
  "chat_room",
  "medication_schedule",
  "ride_request",
  "community_post",
  "daily_record",
  "daily_media",
  "health_record",
  "receipt_record",
  "file_lifecycle",
  "account_deletion",
] as const;
export const ADMIN_APP_SIGNAL_STAGES = [
  "social_login",
  "session_restore",
  "terms_consent_accept",
  "auth_logout",
  "auth_provider_link",
  "auth_provider_unlink",
  "social_profile_me",
  "social_profile_view",
  "social_profile_update",
  "social_follow_create",
  "social_follow_delete",
  "social_follow_check",
  "social_follow_count",
  "user_avatar_upload",
  "user_avatar_confirm",
  "user_profile_update",
  "pet_create",
  "chat_direct_room_list",
  "chat_direct_room_open",
  "chat_direct_message_list",
  "chat_direct_message_send",
  "chat_group_room_list",
  "chat_group_room_create",
  "chat_group_room_join",
  "chat_group_room_leave",
  "chat_group_message_list",
  "chat_group_message_send",
  "medication_list",
  "medication_detail",
  "medication_create",
  "medication_update",
  "medication_delete",
  "medication_complete",
  "medication_skip",
  "medication_snooze",
  "ride_request_list",
  "ride_request_detail",
  "ride_request_create",
  "ride_request_update",
  "ride_request_delete",
  "ride_request_submit",
  "ride_request_cancel",
  "pet_update",
  "pet_delete",
  "pet_photo_confirm",
  "community_image_upload",
  "community_post_create",
  "community_post_update",
  "community_post_delete",
  "community_comment_create",
  "today_status_save",
  "daily_speech_capture_start",
  "daily_speech_capture_cancel",
  "record_update",
  "daily_draft_create",
  "daily_draft_update",
  "daily_draft_discard",
  "daily_record_save",
  "health_file_upload",
  "health_file_confirm",
  "health_analysis_process",
  "health_record_save",
  "receipt_extract",
  "receipt_save",
  "receipt_category_create",
  "receipt_category_update",
  "receipt_category_delete",
  "file_cleanup",
  "account_deletion_request",
  "account_deletion_reauth",
  "account_deletion_process",
] as const;
export const ADMIN_ACCOUNT_DELETION_STATUSES = [
  "none",
  "queued",
  "processing",
  "succeeded",
  "failed",
] as const;
export const ADMIN_JOB_STATUSES = ["queued", "processing", "succeeded", "failed"] as const;
export const ADMIN_JOB_TYPES = [
  "daily_analysis",
  "health_file_analysis",
  "account_deletion",
] as const;
export const ADMIN_AUTH_PROVIDER_KINDS = ["google", "apple", "kakao", "naver", "unknown"] as const;
export const ADMIN_RECORD_TYPES = ["daily", "health", "receipt"] as const;
export const ADMIN_TELEMETRY_LOCALE_BUCKETS = ["ko", "en", "other", "unknown"] as const;
export const ADMIN_TELEMETRY_TIMEZONE_OFFSET_BUCKETS = [
  "utc_minus_12_to_5",
  "utc_minus_4_to_plus_3",
  "utc_plus_4_to_plus_9",
  "utc_plus_10_to_plus_14",
  "unknown",
] as const;
export const ADMIN_TELEMETRY_TIMEZONE_NAME_BUCKETS = [
  "asia_seoul",
  "asia_tokyo",
  "asia_east",
  "southeast_asia",
  "south_asia",
  "europe",
  "north_america_pacific",
  "north_america_mountain",
  "north_america_central",
  "north_america_eastern",
  "oceania",
  "south_america",
  "middle_east_africa",
  "other",
  "unknown",
] as const;
export const ADMIN_TELEMETRY_DEVICE_MODEL_BUCKETS = [
  "apple_phone",
  "apple_tablet",
  "android_phone",
  "android_tablet",
  "web_desktop",
  "web_mobile",
  "unknown",
] as const;
export const ADMIN_TELEMETRY_DEVICE_MODEL_NAME_BUCKETS = [
  "apple_iphone",
  "apple_ipad",
  "samsung_galaxy",
  "samsung_other",
  "google_pixel",
  "android_oem_other",
  "web_browser",
  "unknown",
] as const;
export const ADMIN_TELEMETRY_OS_MAJOR_BUCKETS = [
  "ios_17_or_lower",
  "ios_18_plus",
  "android_13_or_lower",
  "android_14_plus",
  "web_modern",
  "unknown",
] as const;
export const ADMIN_TELEMETRY_OS_VERSION_MINOR_BUCKETS = [
  "ios_17_or_lower",
  "ios_18_0_x",
  "ios_18_1_x",
  "ios_18_2_plus",
  "ios_19_plus",
  "android_13_or_lower",
  "android_14_0_x",
  "android_14_1_plus",
  "android_15_plus",
  "web_runtime",
  "unknown",
] as const;
export const ADMIN_TELEMETRY_NETWORK_TYPE_BUCKETS = [
  "wifi",
  "cellular",
  "ethernet",
  "bluetooth",
  "vpn",
  "wimax",
  "none",
  "other",
  "unknown",
] as const;
export const ADMIN_TELEMETRY_PHYSICAL_DEVICE_BUCKETS = ["physical", "simulator_or_emulator", "unknown"] as const;
export const ADMIN_TELEMETRY_REAUTH_METHOD_BUCKETS = [
  "firebase_id_token",
  "oauth_authorization_code",
  "oauth_access_token",
  "unknown",
] as const;
export const ADMIN_TELEMETRY_RECENT_AUTH_AGE_BUCKETS = [
  "lt_5m",
  "5m_to_30m",
  "30m_to_24h",
  "24h_plus",
  "unknown",
] as const;
export const ADMIN_SOCIAL_TARGET_USER_LOOKUP_KINDS = [
  "self",
  "path_user_id",
  "body_target_user_id",
  "query_target_user_id",
  "unknown",
] as const;
export const ADMIN_SOCIAL_PUBLIC_PET_COUNT_BUCKETS = ["0", "1", "2_to_3", "4_plus", "unknown"] as const;
export const ADMIN_SOCIAL_PROFILE_MUTATION_FIELD_SET_BUCKETS = [
  "display_name_only",
  "bio_only",
  "public_pets_only",
  "display_name_and_bio",
  "display_name_and_public_pets",
  "bio_and_public_pets",
  "display_name_bio_and_public_pets",
  "unknown",
] as const;
export const ADMIN_CHAT_ROOM_KINDS = ["direct", "group", "unknown"] as const;
export const ADMIN_CHAT_MESSAGE_LENGTH_BUCKETS = [
  "1_to_20",
  "21_to_100",
  "101_to_500",
  "501_to_1000",
  "unknown",
] as const;
export const ADMIN_CHAT_MEMBERSHIP_COUNT_BUCKETS = ["1", "2_to_5", "6_plus", "unknown"] as const;
export const ADMIN_MEDICATION_SCHEDULE_RECURRENCE_BUCKETS = ["daily", "weekly", "unknown"] as const;
export const ADMIN_MEDICATION_DOSE_PRESENCE_VALUES = ["present", "absent", "unknown"] as const;
export const ADMIN_MEDICATION_OCCURRENCE_ACTION_KINDS = ["complete", "skip", "snooze", "unknown"] as const;
export const ADMIN_MEDICATION_SNOOZE_WINDOW_BUCKETS = ["lt_30m", "30m_to_2h", "2h_plus", "unknown"] as const;
export const ADMIN_RIDE_VISIT_LEAD_TIME_BUCKETS = ["past_due", "lt_2h", "2h_to_24h", "1d_to_3d", "3d_plus", "unknown"] as const;
export const ADMIN_RIDE_LONGEST_ADDRESS_LENGTH_BUCKETS = ["1_to_40", "41_to_120", "121_to_200", "unknown"] as const;
export const ADMIN_PET_SPECIES_BUCKETS = ["dog", "cat", "other", "unset", "unknown"] as const;
export const ADMIN_PET_BREED_SELECTION_BUCKETS = [
  "species_unset",
  "breed_unset",
  "catalog_match",
  "free_text",
  "unknown",
] as const;
export const ADMIN_PET_PROFILE_COMPLETION_STEPS = [
  "first_pet_name_only",
  "first_pet_profile_details",
  "photo_step",
  "profile_edit",
  "suggestion_apply",
  "unknown",
] as const;
export const ADMIN_PET_PHOTO_CONFIRM_LATENCY_BUCKETS = [
  "lt_5s",
  "5s_to_30s",
  "30s_to_2m",
  "2m_plus",
  "unknown",
] as const;
export const ADMIN_PET_ATTEMPT_COUNT_BUCKETS = ["0", "1", "2_to_3", "4_plus", "unknown"] as const;
export const ADMIN_COMMUNITY_UPLOAD_SOURCE_BUCKETS = ["native_picker_uri", "browser_file", "metadata_only", "unknown"] as const;
export const ADMIN_COMMUNITY_CONTENT_LENGTH_BUCKETS = ["1_to_80", "81_to_240", "241_to_1000", "1001_to_2000", "unknown"] as const;
export const ADMIN_COMMUNITY_IMAGE_COUNT_BUCKETS = ["0", "1", "2_to_3", "4_plus", "unknown"] as const;
export const ADMIN_COMMUNITY_TOPIC_TAGS = [
  "daily-life",
  "health-tip",
  "question",
  "food",
  "behavior",
  "recommendation",
  "none",
  "unknown",
] as const;
export const ADMIN_RECEIPT_EXTRACT_SOURCE_BUCKETS = ["native_picker_uri", "browser_file", "metadata_only", "unknown"] as const;
export const ADMIN_RECEIPT_IMAGE_BYTE_SIZE_BUCKETS = ["lt_1mb", "1mb_to_5mb", "5mb_to_10mb", "10mb_plus", "unknown"] as const;
export const ADMIN_RECEIPT_OCR_CONFIDENCE_BUCKETS = ["lt_50", "50_to_79", "80_to_94", "95_plus", "unknown"] as const;
export const ADMIN_RECEIPT_CATEGORY_MUTATION_TYPES = ["custom_create", "custom_update", "custom_delete", "unknown"] as const;
export const ADMIN_HEALTH_FILE_SIZE_BUCKETS = ["lt_1mb", "1mb_to_5mb", "5mb_to_20mb", "20mb_plus", "unknown"] as const;
export const ADMIN_HEALTH_FILE_TYPE_BUCKETS = ["pdf", "image", "other", "unknown"] as const;
export const ADMIN_HEALTH_ANALYSIS_FALLBACK_PATHS = ["none", "manual_timeout", "unknown"] as const;
export const ADMIN_HEALTH_CONFIRM_TO_SAVE_LATENCY_BUCKETS = ["lt_10s", "10s_to_60s", "1m_to_5m", "5m_plus", "unknown"] as const;
export const ADMIN_LIST_QUERY_DEFAULT_LIMIT = 100;
export const ADMIN_LIST_QUERY_MAX_LIMIT = 100;
export const ADMIN_DEFAULT_TIME_RANGE_DAYS = 30;
export const ADMIN_FULL_HISTORY_TIME_RANGE_START_AT = "1970-01-01T00:00:00.000Z";

export type AdminProjectionFreshness = (typeof ADMIN_PROJECTION_FRESHNESS_VALUES)[number];
export type AdminAppSignalKey = (typeof ADMIN_APP_SIGNAL_KEYS)[number];
export type AdminAppSignalStage = (typeof ADMIN_APP_SIGNAL_STAGES)[number];
export type AdminPlatform = (typeof ADMIN_PLATFORMS)[number];
export type AdminTelemetryLocaleBucket = (typeof ADMIN_TELEMETRY_LOCALE_BUCKETS)[number];
export type AdminTelemetryTimezoneOffsetBucket = (typeof ADMIN_TELEMETRY_TIMEZONE_OFFSET_BUCKETS)[number];
export type AdminTelemetryTimezoneNameBucket = (typeof ADMIN_TELEMETRY_TIMEZONE_NAME_BUCKETS)[number];
export type AdminTelemetryDeviceModelBucket = (typeof ADMIN_TELEMETRY_DEVICE_MODEL_BUCKETS)[number];
export type AdminTelemetryDeviceModelNameBucket = (typeof ADMIN_TELEMETRY_DEVICE_MODEL_NAME_BUCKETS)[number];
export type AdminTelemetryOsMajorBucket = (typeof ADMIN_TELEMETRY_OS_MAJOR_BUCKETS)[number];
export type AdminTelemetryOsVersionMinorBucket = (typeof ADMIN_TELEMETRY_OS_VERSION_MINOR_BUCKETS)[number];
export type AdminTelemetryNetworkTypeBucket = (typeof ADMIN_TELEMETRY_NETWORK_TYPE_BUCKETS)[number];
export type AdminTelemetryPhysicalDeviceBucket = (typeof ADMIN_TELEMETRY_PHYSICAL_DEVICE_BUCKETS)[number];
export type AdminTelemetryReauthMethodBucket = (typeof ADMIN_TELEMETRY_REAUTH_METHOD_BUCKETS)[number];
export type AdminTelemetryRecentAuthAgeBucket = (typeof ADMIN_TELEMETRY_RECENT_AUTH_AGE_BUCKETS)[number];
export type AdminSocialTargetUserLookupKind = (typeof ADMIN_SOCIAL_TARGET_USER_LOOKUP_KINDS)[number];
export type AdminSocialPublicPetCountBucket = (typeof ADMIN_SOCIAL_PUBLIC_PET_COUNT_BUCKETS)[number];
export type AdminSocialProfileMutationFieldSetBucket =
  (typeof ADMIN_SOCIAL_PROFILE_MUTATION_FIELD_SET_BUCKETS)[number];
export type AdminChatRoomKind = (typeof ADMIN_CHAT_ROOM_KINDS)[number];
export type AdminChatMessageLengthBucket = (typeof ADMIN_CHAT_MESSAGE_LENGTH_BUCKETS)[number];
export type AdminChatMembershipCountBucket = (typeof ADMIN_CHAT_MEMBERSHIP_COUNT_BUCKETS)[number];
export type AdminMedicationScheduleRecurrenceBucket =
  (typeof ADMIN_MEDICATION_SCHEDULE_RECURRENCE_BUCKETS)[number];
export type AdminMedicationDosePresence = (typeof ADMIN_MEDICATION_DOSE_PRESENCE_VALUES)[number];
export type AdminMedicationOccurrenceActionKind =
  (typeof ADMIN_MEDICATION_OCCURRENCE_ACTION_KINDS)[number];
export type AdminMedicationSnoozeWindowBucket = (typeof ADMIN_MEDICATION_SNOOZE_WINDOW_BUCKETS)[number];
export type AdminRideVisitLeadTimeBucket = (typeof ADMIN_RIDE_VISIT_LEAD_TIME_BUCKETS)[number];
export type AdminRideLongestAddressLengthBucket = (typeof ADMIN_RIDE_LONGEST_ADDRESS_LENGTH_BUCKETS)[number];
export type AdminCommunityUploadSourceBucket = (typeof ADMIN_COMMUNITY_UPLOAD_SOURCE_BUCKETS)[number];
export type AdminCommunityContentLengthBucket = (typeof ADMIN_COMMUNITY_CONTENT_LENGTH_BUCKETS)[number];
export type AdminCommunityImageCountBucket = (typeof ADMIN_COMMUNITY_IMAGE_COUNT_BUCKETS)[number];
export type AdminCommunityTopicTag = (typeof ADMIN_COMMUNITY_TOPIC_TAGS)[number];
export type AdminReceiptExtractSourceBucket = (typeof ADMIN_RECEIPT_EXTRACT_SOURCE_BUCKETS)[number];
export type AdminReceiptImageByteSizeBucket = (typeof ADMIN_RECEIPT_IMAGE_BYTE_SIZE_BUCKETS)[number];
export type AdminReceiptOcrConfidenceBucket = (typeof ADMIN_RECEIPT_OCR_CONFIDENCE_BUCKETS)[number];
export type AdminReceiptCategoryMutationType = (typeof ADMIN_RECEIPT_CATEGORY_MUTATION_TYPES)[number];
export type AdminHealthFileSizeBucket = (typeof ADMIN_HEALTH_FILE_SIZE_BUCKETS)[number];
export type AdminHealthFileTypeBucket = (typeof ADMIN_HEALTH_FILE_TYPE_BUCKETS)[number];
export type AdminHealthAnalysisFallbackPath = (typeof ADMIN_HEALTH_ANALYSIS_FALLBACK_PATHS)[number];
export type AdminHealthConfirmToSaveLatencyBucket =
  (typeof ADMIN_HEALTH_CONFIRM_TO_SAVE_LATENCY_BUCKETS)[number];
export type AdminPetSpeciesBucket = (typeof ADMIN_PET_SPECIES_BUCKETS)[number];
export type AdminPetBreedSelectionBucket = (typeof ADMIN_PET_BREED_SELECTION_BUCKETS)[number];
export type AdminPetProfileCompletionStep = (typeof ADMIN_PET_PROFILE_COMPLETION_STEPS)[number];
export type AdminPetPhotoConfirmLatencyBucket = (typeof ADMIN_PET_PHOTO_CONFIRM_LATENCY_BUCKETS)[number];
export type AdminPetAttemptCountBucket = (typeof ADMIN_PET_ATTEMPT_COUNT_BUCKETS)[number];
export const ADMIN_TELEMETRY_DRAFT_SOURCE_BUCKETS = ["manual_text", "speech_capture", "mixed", "unknown"] as const;
export type AdminTelemetryDraftSourceBucket = (typeof ADMIN_TELEMETRY_DRAFT_SOURCE_BUCKETS)[number];
export const ADMIN_TELEMETRY_MEDIA_ATTACH_COUNT_BUCKETS = ["0", "1", "2_to_3", "4_plus", "unknown"] as const;
export type AdminTelemetryMediaAttachCountBucket = (typeof ADMIN_TELEMETRY_MEDIA_ATTACH_COUNT_BUCKETS)[number];
export type AdminTelemetryAppBuildNumber = string;
export type AdminDeviceInstallId = string;
export type AdminTimeRange = {
  from: string;
  to: string;
};

export type AdminQueryMeta = {
  requestId: string;
  generatedAt: string;
  sourceFreshness: Record<string, AdminProjectionFreshness>;
  sourceKinds?: Record<string, "projection" | "request_outcome" | "job_projection" | "client_flow_event">;
  nextCursor?: string;
};

export type AdminQueryEnvelope<T> = {
  data: T;
  meta: AdminQueryMeta;
};

export type AdminTopErrorCode = {
  errorCode: string;
  count: number;
  signalKey: AdminAppSignalKey;
  stage?: AdminAppSignalStage;
  topFeature?: string;
  topUseCase?: string;
};

export type AdminUseCaseHealth = {
  feature: string;
  useCase: string;
  signalKey: AdminAppSignalKey;
  stage?: AdminAppSignalStage;
  successCount: number;
  failureCount: number;
  successRate: number;
};

export type AdminJobType = (typeof ADMIN_JOB_TYPES)[number];
export type AdminAuthProviderKind = (typeof ADMIN_AUTH_PROVIDER_KINDS)[number];

export type AdminJobHealth = {
  jobType: AdminJobType;
  signalKey: AdminAppSignalKey;
  queuedCount: number;
  failedCount: number;
  succeededCount: number;
};

export type AdminReleaseHealthSummary = {
  release: string;
  appVersion?: string;
  requestCount: number;
  failureCount: number;
  topErrorCode?: string;
};

export type AdminAccountDeletionStatus = (typeof ADMIN_ACCOUNT_DELETION_STATUSES)[number];

export type AdminLatestFailure = {
  requestId?: string;
  correlationId?: string;
  feature: string;
  useCase: string;
  signalKey?: AdminAppSignalKey;
  stage?: AdminAppSignalStage;
  errorCode: string;
  occurredAt: string;
  providerKind?: AdminAuthProviderKind;
  reauthMethodBucket?: AdminTelemetryReauthMethodBucket;
  recentAuthAgeBucket?: AdminTelemetryRecentAuthAgeBucket;
  requestProfileCompletionStep?: AdminPetProfileCompletionStep;
  requestAttemptCountBucket?: AdminPetAttemptCountBucket;
  requestSpeciesBucket?: AdminPetSpeciesBucket;
  requestBreedSelectionBucket?: AdminPetBreedSelectionBucket;
  requestTargetUserLookupKind?: AdminSocialTargetUserLookupKind;
  requestPublicPetCountBucket?: AdminSocialPublicPetCountBucket;
  requestProfileMutationFieldSetBucket?: AdminSocialProfileMutationFieldSetBucket;
  requestRoomKind?: AdminChatRoomKind;
  requestMessageLengthBucket?: AdminChatMessageLengthBucket;
  requestMembershipCountBucket?: AdminChatMembershipCountBucket;
  requestScheduleRecurrenceBucket?: AdminMedicationScheduleRecurrenceBucket;
  requestDosePresence?: AdminMedicationDosePresence;
  requestOccurrenceActionKind?: AdminMedicationOccurrenceActionKind;
  requestSnoozeWindowBucket?: AdminMedicationSnoozeWindowBucket;
  requestRideVisitLeadTimeBucket?: AdminRideVisitLeadTimeBucket;
  requestRideLongestAddressLengthBucket?: AdminRideLongestAddressLengthBucket;
  requestRideMemoProvided?: boolean;
  requestCommunityUploadSourceBucket?: AdminCommunityUploadSourceBucket;
  requestCommunityContentLengthBucket?: AdminCommunityContentLengthBucket;
  requestCommunityCommentLengthBucket?: AdminCommunityContentLengthBucket;
  requestCommunityImageCountBucket?: AdminCommunityImageCountBucket;
  requestCommunityPetContextAttached?: boolean;
  requestCommunityTopicTag?: AdminCommunityTopicTag;
  requestCommunityRetryCountBucket?: AdminPetAttemptCountBucket;
  requestReceiptExtractSourceBucket?: AdminReceiptExtractSourceBucket;
  requestReceiptImageByteSizeBucket?: AdminReceiptImageByteSizeBucket;
  requestReceiptOcrConfidenceBucket?: AdminReceiptOcrConfidenceBucket;
  requestReceiptManualOverride?: boolean;
  requestReceiptCategoryMutationType?: AdminReceiptCategoryMutationType;
};

export type AdminLatestSuccessfulSave = {
  event: string;
  occurredAt: string;
  signalKey?: AdminAppSignalKey;
  stage?: AdminAppSignalStage;
  requestId?: string;
  correlationId?: string;
  recordType?: AdminRecordType;
  recordId?: string;
  receiptId?: string;
};

export type AdminOverviewSummary = {
  timeRange: AdminTimeRange;
  requestCount: number;
  serverErrorCount: number;
  clientErrorCount: number;
  topErrorCodes: AdminTopErrorCode[];
  useCaseHealth: AdminUseCaseHealth[];
  jobHealth: AdminJobHealth[];
  releaseHealth: AdminReleaseHealthSummary[];
  aiRuntimeOperations?: AdminAiRuntimeOperationsSummary;
  observabilityAggregate?: AdminObservabilityAggregateSummary;
};

export type AdminOverviewQuery = {
  timeRange: AdminTimeRange;
  feature?: string;
  useCase?: string;
};

export type AdminFailedFlowStatus = "failed" | "partial" | "stalled";

export type AdminFailedFlow = {
  id: string;
  createdAt: string;
  feature: string;
  useCase: string;
  signalKey: AdminAppSignalKey;
  stage: AdminAppSignalStage;
  status: AdminFailedFlowStatus;
  requestId?: string;
  correlationId?: string;
  jobId?: string;
  userIdHash?: string;
  petIdHash?: string;
  recordId?: string;
  receiptId?: string;
  fileId?: string;
  deletionJobId?: string;
  errorCode: string;
  statusCode?: number;
  accountIdentity?: AdminAccountIdentitySnapshot;
  release?: string;
  appVersion?: string;
  runtimeAppBuildNumber?: AdminTelemetryAppBuildNumber;
  platform?: AdminPlatform;
  runtimeLocale?: AdminTelemetryLocaleBucket;
  runtimeTimezoneOffsetBucket?: AdminTelemetryTimezoneOffsetBucket;
  runtimeTimezoneNameBucket?: AdminTelemetryTimezoneNameBucket;
  runtimeDeviceModelBucket?: AdminTelemetryDeviceModelBucket;
  runtimeDeviceModelNameBucket?: AdminTelemetryDeviceModelNameBucket;
  runtimeOsMajorBucket?: AdminTelemetryOsMajorBucket;
  runtimeOsVersionMinorBucket?: AdminTelemetryOsVersionMinorBucket;
  runtimeNetworkTypeBucket?: AdminTelemetryNetworkTypeBucket;
  runtimePhysicalDeviceBucket?: AdminTelemetryPhysicalDeviceBucket;
  providerKind?: AdminAuthProviderKind;
  reauthMethodBucket?: AdminTelemetryReauthMethodBucket;
  recentAuthAgeBucket?: AdminTelemetryRecentAuthAgeBucket;
  requestSaveBeforeExit?: boolean;
  requestSuggestionUsed?: boolean;
  requestProfileCompletionStep?: AdminPetProfileCompletionStep;
  requestAttemptCountBucket?: AdminPetAttemptCountBucket;
  requestPhotoConfirmLatencyBucket?: AdminPetPhotoConfirmLatencyBucket;
  requestDraftSourceBucket?: AdminTelemetryDraftSourceBucket;
  requestMediaAttachCountBucket?: AdminTelemetryMediaAttachCountBucket;
  requestSpeciesBucket?: AdminPetSpeciesBucket;
  requestBreedSelectionBucket?: AdminPetBreedSelectionBucket;
  requestTargetUserLookupKind?: AdminSocialTargetUserLookupKind;
  requestPublicPetCountBucket?: AdminSocialPublicPetCountBucket;
  requestProfileMutationFieldSetBucket?: AdminSocialProfileMutationFieldSetBucket;
  requestRoomKind?: AdminChatRoomKind;
  requestMessageLengthBucket?: AdminChatMessageLengthBucket;
  requestMembershipCountBucket?: AdminChatMembershipCountBucket;
  requestScheduleRecurrenceBucket?: AdminMedicationScheduleRecurrenceBucket;
  requestDosePresence?: AdminMedicationDosePresence;
  requestOccurrenceActionKind?: AdminMedicationOccurrenceActionKind;
  requestSnoozeWindowBucket?: AdminMedicationSnoozeWindowBucket;
  requestRideVisitLeadTimeBucket?: AdminRideVisitLeadTimeBucket;
  requestRideLongestAddressLengthBucket?: AdminRideLongestAddressLengthBucket;
  requestRideMemoProvided?: boolean;
  requestCommunityUploadSourceBucket?: AdminCommunityUploadSourceBucket;
  requestCommunityContentLengthBucket?: AdminCommunityContentLengthBucket;
  requestCommunityCommentLengthBucket?: AdminCommunityContentLengthBucket;
  requestCommunityImageCountBucket?: AdminCommunityImageCountBucket;
  requestCommunityPetContextAttached?: boolean;
  requestCommunityTopicTag?: AdminCommunityTopicTag;
  requestCommunityRetryCountBucket?: AdminPetAttemptCountBucket;
  requestReceiptExtractSourceBucket?: AdminReceiptExtractSourceBucket;
  requestReceiptImageByteSizeBucket?: AdminReceiptImageByteSizeBucket;
  requestReceiptOcrConfidenceBucket?: AdminReceiptOcrConfidenceBucket;
  requestReceiptManualOverride?: boolean;
  requestReceiptCategoryMutationType?: AdminReceiptCategoryMutationType;
  requestHealthFileSizeBucket?: AdminHealthFileSizeBucket;
  requestHealthFileTypeBucket?: AdminHealthFileTypeBucket;
  requestHealthAnalysisFallbackPath?: AdminHealthAnalysisFallbackPath;
  requestHealthConfirmToSaveLatencyBucket?: AdminHealthConfirmToSaveLatencyBucket;
  deviceInstallId?: AdminDeviceInstallId;
  lastEventName?: string;
  lastEventAt?: string;
};

export type AdminFailedFlowPage = {
  items: AdminFailedFlow[];
  totalCount?: number;
  observabilityAggregate?: AdminObservabilityAggregateSummary;
};

export type AdminFailedFlowQuery = {
  timeRange: AdminTimeRange;
  feature?: string;
  useCase?: string;
  errorCode?: string;
  statusCode?: number;
  requestId?: string;
  correlationId?: string;
  userIdHash?: string;
  petIdHash?: string;
  release?: string;
  appVersion?: string;
  platform?: AdminPlatform;
  deviceInstallId?: AdminDeviceInstallId;
  cursor?: string;
  limit: number;
};

export type AdminDeviceKpi = {
  deviceInstallId: AdminDeviceInstallId;
  platform: AdminPlatform;
  appVersion?: string;
  release?: string;
  lastSeenAt: string;
  sessionStartCount: number;
  authSuccessCount: number;
  petCreateSuccessCount: number;
  petUpdateSuccessCount: number;
  petDeleteSuccessCount: number;
  petPhotoConfirmSuccessCount: number;
  todayStatusSaveSuccessCount: number;
  dailySpeechCaptureStartCount: number;
  dailySpeechCaptureCancelCount: number;
  dailyDraftCreateSuccessCount: number;
  dailyDraftUpdateCount: number;
  dailyDraftDiscardCount: number;
  dailyRecordSaveSuccessCount: number;
  dailyMediaUpdateSuccessCount: number;
  healthFileUploadSuccessCount: number;
  healthFileConfirmSuccessCount: number;
  healthAnalysisStartCount: number;
  healthRecordSaveSuccessCount: number;
  receiptExtractCount: number;
  receiptSaveSuccessCount: number;
  receiptCategoryCreateSuccessCount: number;
  receiptCategoryUpdateSuccessCount: number;
  receiptCategoryDeleteSuccessCount: number;
  socialSuccessCount: number;
  chatSuccessCount: number;
  communitySuccessCount: number;
  medicationSuccessCount: number;
  rideRequestSuccessCount: number;
  failureCount: number;
  topErrorCode?: string;
  latestUserIdHash?: string;
  latestUserAccountIdentity?: AdminAccountIdentitySnapshot;
  latestRuntimeAppBuildNumber?: AdminTelemetryAppBuildNumber;
  latestRuntimeLocale?: AdminTelemetryLocaleBucket;
  latestRuntimeTimezoneOffsetBucket?: AdminTelemetryTimezoneOffsetBucket;
  latestRuntimeTimezoneNameBucket?: AdminTelemetryTimezoneNameBucket;
  latestRuntimeDeviceModelBucket?: AdminTelemetryDeviceModelBucket;
  latestRuntimeDeviceModelNameBucket?: AdminTelemetryDeviceModelNameBucket;
  latestRuntimeOsMajorBucket?: AdminTelemetryOsMajorBucket;
  latestRuntimeOsVersionMinorBucket?: AdminTelemetryOsVersionMinorBucket;
  latestRuntimeNetworkTypeBucket?: AdminTelemetryNetworkTypeBucket;
  latestRuntimePhysicalDeviceBucket?: AdminTelemetryPhysicalDeviceBucket;
  latestRuntimeContextAt?: string;
  latestPetProfileCompletionStep?: AdminPetProfileCompletionStep;
  latestPetAttemptCountBucket?: AdminPetAttemptCountBucket;
  latestPetSpeciesBucket?: AdminPetSpeciesBucket;
  latestPetBreedSelectionBucket?: AdminPetBreedSelectionBucket;
  latestPetContextAt?: string;
  latestSocialTargetUserLookupKind?: AdminSocialTargetUserLookupKind;
  latestSocialPublicPetCountBucket?: AdminSocialPublicPetCountBucket;
  latestSocialProfileMutationFieldSetBucket?: AdminSocialProfileMutationFieldSetBucket;
  latestSocialContextAt?: string;
  latestChatRoomKind?: AdminChatRoomKind;
  latestChatMessageLengthBucket?: AdminChatMessageLengthBucket;
  latestChatMembershipCountBucket?: AdminChatMembershipCountBucket;
  latestChatContextAt?: string;
  latestReceiptExtractSourceBucket?: AdminReceiptExtractSourceBucket;
  latestReceiptImageByteSizeBucket?: AdminReceiptImageByteSizeBucket;
  latestReceiptOcrConfidenceBucket?: AdminReceiptOcrConfidenceBucket;
  latestReceiptManualOverride?: boolean;
  latestReceiptCategoryMutationType?: AdminReceiptCategoryMutationType;
  latestReceiptContextAt?: string;
  latestMedicationScheduleRecurrenceBucket?: AdminMedicationScheduleRecurrenceBucket;
  latestMedicationDosePresence?: AdminMedicationDosePresence;
  latestMedicationOccurrenceActionKind?: AdminMedicationOccurrenceActionKind;
  latestMedicationSnoozeWindowBucket?: AdminMedicationSnoozeWindowBucket;
  latestMedicationContextAt?: string;
  latestRideVisitLeadTimeBucket?: AdminRideVisitLeadTimeBucket;
  latestRideLongestAddressLengthBucket?: AdminRideLongestAddressLengthBucket;
  latestRideMemoProvided?: boolean;
  latestRideContextAt?: string;
  latestDailySpeechDurationBucket?: string;
  latestDailySpeechDurationBucketAt?: string;
  latestDailyDraftEditCountBucket?: string;
  latestDailyDraftEditCountBucketAt?: string;
  latestDailyDraftDiscardReasonCategory?: string;
  latestDailyDraftDiscardReasonCategoryAt?: string;
};

export type AdminDeviceKpiPage = {
  items: AdminDeviceKpi[];
  totalCount?: number;
};

export type AdminDeviceKpiQuery = {
  timeRange: AdminTimeRange;
  platform?: AdminPlatform;
  appVersion?: string;
  release?: string;
  deviceInstallId?: AdminDeviceInstallId;
  cursor?: string;
  limit: number;
};

export type AdminUserDataCounts = {
  pets: number;
  records: number;
  dailyRecords: number;
  healthRecords: number;
  receipts: number;
  files: number;
  aiJobs: number;
};

export type AdminUserDataRiskLevel = "attention" | "warning" | "critical";

export type AdminUserDataRiskItem = {
  code:
    | "FILE_CLEANUP_FAILED"
    | "FILE_CLEANUP_PENDING"
    | "FILE_CONFIRMED_LINK_MISSING"
    | "FILE_TEMP_EXPIRED"
    | "AI_JOB_FAILED"
    | "ACCOUNT_DELETION_FAILED"
    | "PET_FLOW_FAILED"
    | "PET_PROFILE_MISSING_REQUIRED"
    | "PET_PHOTO_LINK_MISSING";
  level: AdminUserDataRiskLevel;
  label: string;
  evidence: string;
};

export type AdminUserDataRiskSummary = {
  highestLevel: AdminUserDataRiskLevel | "none";
  items: AdminUserDataRiskItem[];
};

export type AdminUserSummary = {
  internalUserId: string;
  userIdHash: string;
  createdAt: string;
  lastLoginAt?: string;
  termsConsentAt?: string;
  accountIdentity?: AdminAccountIdentitySnapshot;
  accountDeletionStatus?: AdminAccountDeletionStatus;
  latestDeviceInstallId?: AdminDeviceInstallId;
  latestPlatform?: AdminPlatform;
  latestRelease?: string;
  latestAppVersion?: string;
  latestRuntimeAppBuildNumber?: AdminTelemetryAppBuildNumber;
  latestRuntimeLocale?: AdminTelemetryLocaleBucket;
  latestRuntimeTimezoneOffsetBucket?: AdminTelemetryTimezoneOffsetBucket;
  latestRuntimeTimezoneNameBucket?: AdminTelemetryTimezoneNameBucket;
  latestRuntimeDeviceModelBucket?: AdminTelemetryDeviceModelBucket;
  latestRuntimeDeviceModelNameBucket?: AdminTelemetryDeviceModelNameBucket;
  latestRuntimeOsMajorBucket?: AdminTelemetryOsMajorBucket;
  latestRuntimeOsVersionMinorBucket?: AdminTelemetryOsVersionMinorBucket;
  latestRuntimeNetworkTypeBucket?: AdminTelemetryNetworkTypeBucket;
  latestRuntimePhysicalDeviceBucket?: AdminTelemetryPhysicalDeviceBucket;
  latestRuntimeContextAt?: string;
  counts: AdminUserDataCounts;
  riskSummary: AdminUserDataRiskSummary;
  latestFailure?: AdminLatestFailure;
  latestSuccessfulSave?: AdminLatestSuccessfulSave;
  recentFailures: AdminLatestFailure[];
  recentSuccessfulSaves: AdminLatestSuccessfulSave[];
};

export type AdminUserLookupInput = {
  internalUserId?: string;
  userIdHash?: string;
  requestId?: string;
  correlationId?: string;
};

export type AdminUserSummaryPage = {
  items: AdminUserSummary[];
  totalCount?: number;
};

export type AdminUserSummaryQuery = {
  timeRange: AdminTimeRange;
  cursor?: string;
  limit: number;
};

export type AdminPetSpecies = "dog" | "cat" | "unknown";

export type AdminPetData = {
  petId: string;
  petIdHash: string;
  createdAt: string;
  updatedAt?: string;
  deletedAt?: string;
  species?: AdminPetSpecies;
  profileStatus: "complete" | "missing_required" | "deleted";
  photoFileLinkStatus: "none" | "linked" | "missing_file" | "file_deleted";
  recordCount: number;
};

export type AdminRecordType = (typeof ADMIN_RECORD_TYPES)[number];
export type AdminJobStatus = (typeof ADMIN_JOB_STATUSES)[number];

export type AdminRecordData = {
  recordId: string;
  type: AdminRecordType;
  title?: string;
  recordedAt: string;
  createdAt: string;
  updatedAt?: string;
  deletedAt?: string;
  linkedFileCount: number;
  latestAiJobStatus?: "none" | AdminJobStatus;
  dataCompleteness: "complete" | "partial" | "fallback" | "unknown";
};

export type AdminReceiptData = {
  receiptId: string;
  purchasedAt?: string;
  amountBucket: "none" | "under_10000" | "under_50000" | "under_100000" | "over_100000";
  categoryLabel?: string;
  createdAt: string;
  updatedAt?: string;
  deletedAt?: string;
  extractionStatus?: "none" | "draft_created" | "fallback" | "failed";
};

export type AdminFileData = {
  fileId: string;
  purpose:
    | "pet_profile_photo"
    | "user_avatar"
    | "health_source"
    | "health_record_source"
    | "receipt_source"
    | "daily_record_photo"
    | "daily_record_video"
    | "community_post_image"
    | "unknown";
  status:
    | "temp"
    | "confirmed"
    | "expired"
    | "deleted"
    | "cleanup_scheduled"
    | "cleanup_processed"
    | "cleanup_failed";
  contentType?: string;
  sizeBucket: "unknown" | "under_1mb" | "under_10mb" | "over_10mb";
  linkedEntityType?: "pet" | "user" | "record" | "receipt" | "community_post";
  linkedEntityId?: string;
  createdAt: string;
  confirmedAt?: string;
  expiresAt?: string;
  deletedAt?: string;
  storageDeletedAt?: string;
  latestLifecycleRequestId?: string;
  upstreamRequestId?: string;
  cleanupScheduledAgeBucket?: "immediate" | "lt_5m" | "5m_to_30m" | "30m_plus" | "unknown";
  cleanupAttemptCountBucket?: "0" | "1" | "2_to_3" | "4_plus" | "unknown";
  orphanClassification?: "expired_temp_file" | "deleted_file_pending_storage_cleanup" | "unknown";
  storageDeleteOutcomeCategory?:
    | "not_started"
    | "zero_candidates"
    | "all_deleted"
    | "partial_deleted"
    | "none_deleted"
    | "request_failed"
    | "unknown";
  linkedEntityKind?: "pet" | "user" | "record" | "receipt" | "mixed" | "unknown";
};

export type AdminMediaArtifactSourceScenario =
  | "avatar"
  | "pet_profile"
  | "daily_record"
  | "receipt"
  | "health_record"
  | "community_post"
  | "unknown";

export type AdminMediaArtifactRelationType = "direct" | "contextual";
export type AdminMediaArtifactRole =
  | "representative"
  | "gallery_member"
  | "original_only"
  | "evidence_sidecar";
export type AdminMediaArtifactKind = "image" | "video" | "document" | "unknown";
export type AdminMediaArtifactContentTypeBucket =
  | "image_jpeg"
  | "image_png"
  | "image_heic"
  | "image_webp"
  | "video_mp4"
  | "document_image_like"
  | "application_pdf"
  | "other"
  | "unknown";
export type AdminMediaArtifactSizeBucket =
  | "lt_1mb"
  | "1mb_to_10mb"
  | "10mb_plus"
  | "unknown";
export type AdminMediaArtifactStorageStatus =
  | "available"
  | "pending_confirm"
  | "soft_deleted"
  | "cleanup_scheduled"
  | "deleted"
  | "retention_expired"
  | "unknown";
export type AdminMediaArtifactAvailability =
  | "available"
  | "pending_policy_check"
  | "unsupported_type"
  | "not_generated"
  | "deleted"
  | "retention_expired"
  | "access_denied"
  | "unknown";
export type AdminMediaArtifactFallbackReason =
  | "missing"
  | "build_not_supported"
  | "capture_pending"
  | "upload_failed"
  | "unsupported_type"
  | "pending_confirm"
  | "cleanup_scheduled"
  | "deleted"
  | "retention_expired"
  | "access_denied"
  | "manual_resend_required"
  | "unknown";
export type AdminMediaArtifactAuditScope =
  | "preview_only"
  | "download_only"
  | "preview_and_download"
  | "metadata_only";
export type AdminMediaArtifactAccessAction = "preview" | "download";
export type AdminMediaArtifactAccessResult =
  | "allowed"
  | "denied_policy"
  | "denied_role"
  | "expired"
  | "missing"
  | "unknown";
export type AdminIncidentLogArtifactAccessAction = "download";

export type AdminMediaArtifactTraceKey = {
  requestId?: string;
  correlationId?: string;
  signalKey?: AdminAppSignalKey;
  stage?: AdminAppSignalStage;
};

export type AdminMediaArtifactData = {
  artifactId: string;
  sourceScenario: AdminMediaArtifactSourceScenario;
  linkedEntityType?:
    | "user"
    | "pet"
    | "record"
    | "receipt"
    | "file"
    | "community_post"
    | "unknown";
  linkedEntityId?: string;
  relationType: AdminMediaArtifactRelationType;
  artifactRole: AdminMediaArtifactRole;
  mediaKind: AdminMediaArtifactKind;
  contentTypeBucket: AdminMediaArtifactContentTypeBucket;
  sizeBucket: AdminMediaArtifactSizeBucket;
  uploadedAt: string;
  confirmedAt?: string;
  storageStatus: AdminMediaArtifactStorageStatus;
  previewAvailability: AdminMediaArtifactAvailability;
  downloadAvailability: AdminMediaArtifactAvailability;
  fallbackReason?: AdminMediaArtifactFallbackReason;
  latestTraceKey?: AdminMediaArtifactTraceKey;
  auditScope: AdminMediaArtifactAuditScope;
  sameDeviceContextAvailable: boolean;
};

export type AdminIncidentLogCaptureTrigger =
  | "failed_request"
  | "fatal_boundary"
  | "operator_resend"
  | "upload_recovery"
  | "unknown";

export type AdminIncidentLogCaptureWindow =
  | "pre_30s_post_30s"
  | "pre_2m_post_2m"
  | "session_excerpt"
  | "unknown";

export type AdminIncidentLogCapturedAtBucket =
  | "lt_15m"
  | "15m_to_1h"
  | "1h_to_24h"
  | "24h_plus"
  | "unknown";

export type AdminIncidentLogSupportabilityState =
  | "supported"
  | "build_not_supported"
  | "capture_disabled"
  | "capture_pending"
  | "capture_pending_upload"
  | "upload_in_progress"
  | "upload_failed"
  | "superseded"
  | "retention_expired"
  | "access_denied"
  | "manual_resend_required"
  | "unknown";

export type AdminIncidentLogExcerptLineCountBucket =
  | "0"
  | "1_to_20"
  | "21_to_100"
  | "101_plus"
  | "unknown";

export type AdminIncidentLogBundleHashPresence = "present" | "missing" | "unknown";

export type AdminIncidentLogManifestVersion = "incident_log_manifest.v1";

export type AdminIncidentLogRedactionVersion = "incident_log_redaction.v1";

export type AdminIncidentLogPreviewReadiness =
  | "ready"
  | "processing"
  | "unsupported"
  | "empty_excerpt"
  | "retention_expired"
  | "access_denied"
  | "unknown";

export type AdminIncidentLogDownloadReadiness =
  | "ready"
  | "processing"
  | "missing_manifest"
  | "retention_expired"
  | "access_denied"
  | "unknown";

export type AdminIncidentLogHandoffReadiness =
  | "ready"
  | "needs_preview_only"
  | "needs_resend"
  | "blocked_by_policy"
  | "unknown";

export type AdminIncidentLogTraceKey = {
  requestId?: string;
  correlationId?: string;
  signalKey?: AdminAppSignalKey;
  stage?: AdminAppSignalStage;
  errorCode?: string;
};

export type AdminIncidentLogPreviewLineLevel =
  | "debug"
  | "info"
  | "warning"
  | "error"
  | "fatal"
  | "unknown";

export type AdminIncidentLogPreviewLine = {
  timestamp: string;
  level: AdminIncidentLogPreviewLineLevel;
  category: string;
  messageKey: string;
  redactedContext: string;
  requestId?: string;
  correlationId?: string;
  errorCode?: string;
};

export type AdminIncidentLogPreviewExcerpt = {
  headline?: string;
  topCategory?: string;
  lines: AdminIncidentLogPreviewLine[];
};

export type AdminIncidentLogArtifactData = {
  artifactId: string;
  deviceInstallId: string;
  release: string;
  appVersion: string;
  platform: AdminPlatform;
  runtimeAppBuildNumber?: AdminTelemetryAppBuildNumber;
  runtimeLocale?: AdminTelemetryLocaleBucket;
  runtimeTimezoneOffsetBucket?: AdminTelemetryTimezoneOffsetBucket;
  runtimeTimezoneNameBucket?: AdminTelemetryTimezoneNameBucket;
  runtimeDeviceModelBucket?: AdminTelemetryDeviceModelBucket;
  runtimeDeviceModelNameBucket?: AdminTelemetryDeviceModelNameBucket;
  runtimeOsMajorBucket?: AdminTelemetryOsMajorBucket;
  runtimeOsVersionMinorBucket?: AdminTelemetryOsVersionMinorBucket;
  runtimeNetworkTypeBucket?: AdminTelemetryNetworkTypeBucket;
  runtimePhysicalDeviceBucket?: AdminTelemetryPhysicalDeviceBucket;
  captureTrigger: AdminIncidentLogCaptureTrigger;
  captureWindow: AdminIncidentLogCaptureWindow;
  capturedAtBucket: AdminIncidentLogCapturedAtBucket;
  capturedAtOperatorValue?: string;
  supportabilityState: AdminIncidentLogSupportabilityState;
  excerptLineCountBucket: AdminIncidentLogExcerptLineCountBucket;
  bundleHashPresence: AdminIncidentLogBundleHashPresence;
  manifestVersion?: AdminIncidentLogManifestVersion;
  redactionVersion?: AdminIncidentLogRedactionVersion;
  previewReadiness: AdminIncidentLogPreviewReadiness;
  downloadReadiness: AdminIncidentLogDownloadReadiness;
  previewExcerpt?: AdminIncidentLogPreviewExcerpt;
  latestTraceKey?: AdminIncidentLogTraceKey;
  handoffReadiness: AdminIncidentLogHandoffReadiness;
};

export type AdminMediaArtifactAccessGrant = {
  artifactId: string;
  action: AdminMediaArtifactAccessAction;
  accessResult: AdminMediaArtifactAccessResult;
  issuedAt: string;
  expiresAt?: string;
  url?: string;
};

export type AdminIncidentLogArtifactAccessGrant = {
  artifactId: string;
  action: AdminIncidentLogArtifactAccessAction;
  accessResult: AdminMediaArtifactAccessResult;
  issuedAt: string;
  expiresAt?: string;
  url?: string;
};

export type AdminJobData = {
  jobId: string;
  jobType: AdminJobType;
  signalKey: AdminAppSignalKey;
  ownerUserIdHash?: string;
  petIdHash?: string;
  status: AdminJobStatus;
  attemptCount: number;
  lastErrorCode?: string;
  provider?: string;
  queuedAt?: string;
  startedAt?: string;
  finishedAt?: string;
  durationMs?: number;
  linkedFileId?: string;
  linkedRecordId?: string;
};

export type AdminJobPage = {
  items: AdminJobData[];
  totalCount?: number;
  aiRuntimeOperations?: AdminAiRuntimeOperationsSummary;
  observabilityAggregate?: AdminObservabilityAggregateSummary;
};

export type AdminJobQuery = {
  timeRange: AdminTimeRange;
  jobType?: AdminJobType;
  status?: AdminJobStatus;
  userIdHash?: string;
  petIdHash?: string;
  linkedFileId?: string;
  linkedRecordId?: string;
  requestId?: string;
  correlationId?: string;
  release?: string;
  appVersion?: string;
  cursor?: string;
  limit: number;
};

export type AdminAccountIdentitySnapshot = {
  accountEmail?: string;
  emailVerified?: boolean;
  displayName?: string;
  provider?: AdminAuthProviderKind;
  providerEmail?: string;
  providerEmailVerified?: boolean;
  providerDisplayName?: string;
  providerLinkedAt?: string;
  linkedProviderCount?: number;
};

export type AdminAccountData = AdminAccountIdentitySnapshot & {
  termsConsentAt?: string;
  lastLoginAt?: string;
  logoutLastSeenAt?: string;
  deletionRequestedAt?: string;
  deletionCompletedAt?: string;
  deletionJobStatus?: AdminAccountDeletionStatus;
};

export type AdminUploadDiagnosisEnrichment = {
  ocrProviderName?: string;
  ocrStatus?: string;
  ocrConfidenceSummary?: string;
  aiStructuringModel?: string;
  aiStructuringStatus?: string;
  manualReviewReason?: string;
  elapsedTimeBucket?: string;
};

export type AdminAiRuntimeOperationsSummary = {
  aiProviderRouteLabel?: string;
  aiQuotaState?: string;
  aiServingAccessState?: string;
  aiBudgetThresholdState?: string;
  aiProviderLatencyBucket?: string;
  manualReviewFallbackPressure?: string;
  aiModelUsageLineage?: string;
  aiModelUsageSummary?: string;
  aiModelLimitSummary?: string;
};

export type AdminObservabilityAggregateSummary = {
  businessFlowCompletionRate?: string;
  failureReasonBucketSummary?: string;
  releaseErrorSpikeSummary?: string;
  jobRetryPressure?: string;
  oldestQueuedAgeBucket?: string;
  terminalFailureCodeDistribution?: string;
  providerFailureDistribution?: string;
};

export type AdminUserUploadDiagnosis = {
  health?: {
    analysis?: AdminUploadDiagnosisEnrichment;
  };
  receipt?: {
    extract?: AdminUploadDiagnosisEnrichment;
    save?: AdminUploadDiagnosisEnrichment;
  };
  daily?: {
    analysis?: AdminUploadDiagnosisEnrichment;
  };
};

export type AdminUserDataDetail = {
  user: AdminUserSummary;
  pets: AdminPetData[];
  records: AdminRecordData[];
  receipts: AdminReceiptData[];
  files: AdminFileData[];
  representativePhoto?: AdminMediaArtifactData;
  mediaArtifacts?: AdminMediaArtifactData[];
  incidentLogArtifacts?: AdminIncidentLogArtifactData[];
  aiJobs: AdminJobData[];
  account: AdminAccountData;
  uploadDiagnosis?: AdminUserUploadDiagnosis;
};

export type AdminReleaseRegressionSlice = {
  release: string;
  appVersion?: string;
  deployedAt?: string;
  requestCount: number;
  errorRate: number;
  topFailedUseCase?: string;
  topErrorCode?: string;
  jobFailureDelta?: number;
  platformConcentration?: Partial<Record<AdminPlatform, number>>;
};

export type AdminReleaseRegression = {
  timeRange: AdminTimeRange;
  items: AdminReleaseRegressionSlice[];
  aiRuntimeOperations?: AdminAiRuntimeOperationsSummary;
  observabilityAggregate?: AdminObservabilityAggregateSummary;
};

export type AdminReleaseRegressionQuery = {
  timeRange: AdminTimeRange;
  release?: string;
  appVersion?: string;
  platform?: AdminPlatform;
  cursor?: string;
  limit: number;
};
